module.exports = __webpack_public_path__ + "static/6-meditaciones-42eb8fdecc86668aa9a09a1d90fdcd91.jpg";